import { NgModule } from '@angular/core';
import { SchedeIntervento_PersonaInTeamPipe } from './schede-intervento-team.pipe';

@NgModule({
  declarations: [SchedeIntervento_PersonaInTeamPipe],
  exports: [SchedeIntervento_PersonaInTeamPipe],
})
export class SchedeInterventoTeamPipeModule {}
